import { API } from "../apis/APIsConfig";
import Constants from "../utils/constants";

export function getRelatives() {
  return API.get(Constants.APIURLS.RELATIVES);
}

export function saveInscription(data: any) {
  return API.post(Constants.APIURLS.SAVEINSCRIPTION, data);
}
